var map = {
	"./af.json": 1477,
	"./am.json": 74857,
	"./ar.json": 10032,
	"./az.json": 15367,
	"./be.json": 33485,
	"./bg.json": 37179,
	"./bn.json": 40146,
	"./br.json": 36255,
	"./bs.json": 25362,
	"./ca.json": 35350,
	"./cs.json": 43970,
	"./cy.json": 3935,
	"./da.json": 4717,
	"./de.json": 46770,
	"./dv.json": 65718,
	"./el.json": 3415,
	"./en.json": 19411,
	"./es.json": 64406,
	"./et.json": 52939,
	"./eu.json": 12065,
	"./fa.json": 874,
	"./fi.json": 28376,
	"./fr.json": 60688,
	"./gl.json": 84369,
	"./ha.json": 86377,
	"./he.json": 12607,
	"./hi.json": 87746,
	"./hr.json": 72039,
	"./hu.json": 7764,
	"./hy.json": 66650,
	"./id.json": 20796,
	"./is.json": 13969,
	"./it.json": 18644,
	"./ja.json": 70966,
	"./ka.json": 23573,
	"./kk.json": 48764,
	"./km.json": 99919,
	"./ko.json": 86069,
	"./ku.json": 21486,
	"./ky.json": 79144,
	"./lt.json": 37221,
	"./lv.json": 66907,
	"./mk.json": 52423,
	"./ml.json": 48255,
	"./mn.json": 55518,
	"./mr.json": 12775,
	"./ms.json": 49535,
	"./nb.json": 10749,
	"./nl.json": 16581,
	"./nn.json": 11656,
	"./no.json": 47467,
	"./pl.json": 91949,
	"./ps.json": 51453,
	"./pt.json": 67224,
	"./ro.json": 11920,
	"./ru.json": 37062,
	"./sd.json": 43508,
	"./sk.json": 5974,
	"./sl.json": 81595,
	"./so.json": 41707,
	"./sq.json": 92050,
	"./sr.json": 21360,
	"./sv.json": 35534,
	"./sw.json": 78828,
	"./ta.json": 50059,
	"./tg.json": 19555,
	"./th.json": 69757,
	"./tr.json": 34925,
	"./tt.json": 37,
	"./ug.json": 74600,
	"./uk.json": 3631,
	"./ur.json": 39246,
	"./uz.json": 94368,
	"./vi.json": 97191,
	"./zh.json": 77657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93097;